<template>
  <div
    class="image-gallery-photos-container"
    :style="{
            gridTemplateColumns: `repeat(${internal_config.columns}, auto)`,
            gridColumnGap: `${internal_config.verticalMargin}px`,
            gridRowGap: `${internal_config.horizontalMargin}px`,
            opacity: opacity
          }"
  >
    <div
      class="image-gallery-photo"
      v-for="(image, index) in internal_config.images"
      :key="image"
      :style="{
              backgroundImage: 'url(' + image + ')',
              cursor: $props.preview ? 'pointer': '',
              borderRadius: radius,
              border : border
             }"
      @click="$emit('showPhoto', index)"
    ></div>
  </div>
</template>

<script>

export default {
  name: "MatrizGallery",
  props: ['internal_config'],
  computed: {
    minHeight() {
      return this.internal_config.minHeight;
    },
    opacity() {
      return this.internal_config.opacity;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    }
  },
}
</script>

<style lang="scss" scoped>
/** GALLERY */

.image-gallery-container {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 80% 20%;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.image-gallery-photos-container {
  display: grid;
  width: 100%;
  height: 100%;
}

.image-gallery-photo {
  overflow: hidden;
  float: left;
  background-position: top center;
  background-size: cover;
  position: relative;
}
</style>
